import { route } from '@betterment/js-runtime';

import brochureUrl from './brochureUrl';
import { employerScopedRoute } from './pathHelpers';

export const urlBuilder = {
  // routes sorted alphabetically
  appHome: route('', []),
  compliance: route('', ['compliance']),
  currentEmployer: route('', ['current_employer', { param: 'employerId' }]),
  dashboard: route('', ['/dashboard']),
  employee: route('', ['employees', { param: 'employeeId' }]),
  employees: route('', ['employees']),
  fiveTwoNine: route('', ['/five_two_nines/overview']),
  help: route('', ['help']),
  onboarding: route('', ['employer_onboarding_tasks']),
  payroll: route('', ['payroll_overview']),
  plan: route('', ['/plan']),
  profile: route('', ['profile']),
  profileEmailPreferencesEdit: route('', ['profile', 'email_preferences', 'edit']),
  reports: employerScopedRoute(['reports']),
  reportsNew: employerScopedRoute(['reports', 'new']),
  reportsSuccess: employerScopedRoute(['reports', 'success']),
  resources: route('', ['education']),
  settings: route('', ['settings']),
  signOut: route('', ['plan_managers', 'sign_out']),
  support: route('', ['/support']),
  tasks: route('', ['/tasks']),
  unallocatedFundsAutomationEdit: route('', ['unallocated_funds_automation', 'edit']),

  // For setting up the graphQL client
  graphQL: route('', ['/graphql']),

  getReportCsvDownload(reportId: string) {
    return `/reports/${reportId}.csv`;
  },
  getDeconversionPackageDownload() {
    return '/plan_reports/deconversion_package';
  },
  getInvestmentActivityPackageDownload(reportId: string) {
    return `/plan_reports/investment_activity_packages/${reportId}`;
  },
  getSignablePackageDownload(signablePackageId: string) {
    return `/signable_package_download/${signablePackageId}`;
  },
  getSignablePackageSuccess(signablePackageId: string, returnToPath?: string) {
    return `/signable_packages/${signablePackageId}/success${returnToPath ? `?returnTo=${encodeURIComponent(returnToPath)}` : ''}`;
  },

  // brochure links
  getResources() {
    return brochureUrl('/work/resources');
  },
  getUnallocatedFundsGuide() {
    return brochureUrl('/work/resources/what-are-unallocated-funds');
  },
};
